import React, { useEffect, useMemo } from 'react';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import { Title } from 'components/Misc/Typography';

// import Child from 'containers/Parent/Payments/Child';
import All from 'containers/Parent/Payments/Read/All';
import Latest from 'containers/Parent/Payments/Read/Latest';

import { useAppStore } from 'store/useAppStore';
import { useParentPaymentStore } from 'store/parent/useParentPaymentStore';

const Read = () => {
	// Store requested user
	const [[result, progress], collect] = useCollect('payments');

	// Use student's payment store
	const [onInit, onReset] = useParentPaymentStore(state => [
		state.onInit,
		state.onReset
	]);

	// Collect user on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize user's data after collection
	useEffect(() => {
		if (result) onInit(result);

		// Reset mark's data on unmount
		return () => onReset();
	}, [result]);

	return (
		<div className="space-y-4 mx-auto max-w-screen-md">
			<Title title="Maksājumi" className="text-2xl" />

			{/* Closest payment */}
			<Latest progress={progress} />

			{/* Show all payments */}
			<All progress={progress} />
		</div>
	);
};

export default Read;